import { Button, Grid } from "@mui/material";
import { Panel } from "@poseidon/ui/components/Panel";
import React from "react";
import LinearProgress from "@mui/material/LinearProgress";
import EditApplicationFormWrapper from "./EditApplicationFormWrapper";
import { useDealers } from "../../../Dealers/hooks/useDealers";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useApplicationContext } from "./ApplicationContext";
import { Field } from "formik";
import { FullWidthField } from "@poseidon/ui/components";
import { AutoComplete } from "@poseidon/ui/components/AutoComplete";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkbox } from "formik-mui";
import { usePorts } from "../../../Boats/BoatOptionsContext";

export function McaPanel() {
  const application = useApplicationContext();
  const { loading, error } = useDealers(true, application.id);
  const ports = usePorts();
  const { setError } = useErrorMessage();
  if (error) {
    setError(error);
  }

  if (loading) {
    return <LinearProgress />;
  }
  const initialValues = {
    mcaRegistrationRequired: application.mcaRegistrationRequired ?? false,
    portOfRegistration: application.portOfRegistration ?? "",
    portPreferredVesselNameOne: application.portPreferredVesselNameOne ?? "",
    portPreferredVesselNameTwo: application.portPreferredVesselNameTwo ?? "",
    portPreferredVesselNameThree:
      application.portPreferredVesselNameThree ?? "",
  };
  return (
    <EditApplicationFormWrapper
      initialValues={initialValues}
      application={application}
    >
      {({ dirty, isSubmitting }) => {
        return (
          <Panel
            title="MCA Registration"
            expandable
            anchorName="mca-details"
            actions={
              <Button
                size="small"
                type="submit"
                disabled={!dirty || isSubmitting}
              >
                Save
              </Button>
            }
          >
            <Grid container spacing={2} mt={0}>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Field
                      component={Checkbox}
                      type="checkbox"
                      name="mcaRegistrationRequired"
                    />
                  }
                  label="Requires MCA Registration"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <AutoComplete
                  label="Port Of Registration (if applicable)"
                  name="portOfRegistration"
                  options={ports}
                  loading={!ports?.length}
                  margin="none"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Field
                  component={FullWidthField}
                  name="portPreferredVesselNameOne"
                  label="1st Preference Vessel Name"
                  margin="none"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Field
                  component={FullWidthField}
                  name="portPreferredVesselNameTwo"
                  label="2nd Preference Vessel Name"
                  margin="none"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Field
                  component={FullWidthField}
                  name="portPreferredVesselNameThree"
                  label="3rd Preference Vessel Name"
                  margin="none"
                />
              </Grid>
            </Grid>
          </Panel>
        );
      }}
    </EditApplicationFormWrapper>
  );
}
